import React from 'react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { createRoot } from 'react-dom/client';

const distVafTheme = createTheme({
    palette: {
        primary: {
            main: '#337AB7',
        },
        secondary: {
            main: '#b2102f',
        },
        error: {
            main: '#b2102f',
        },
        success: {
            main: '#33b7b2',
            contrastText: '#fff'
        }
    },
    typography: {
        fontFamily: 'Roboto, sans-serif',
    }
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <ThemeProvider theme={distVafTheme}>
        <App />
    </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
